import { Icons } from "../models/assets-files";

interface AppHeaderItem {
  id: AppHeaderItemId;
  icon: string;
  path: string;
}

export enum AppHeaderItemId {
  REFRESH = "refresh",
  NOTIFICATIONS = "notifications",
  CHAT = "chat",
  LOGOUT = "logout",
}

export const appHeaderItems: AppHeaderItem[] = [
  {
    id: AppHeaderItemId.NOTIFICATIONS,
    icon: Icons.AppHeader.NotificationBell,
    path: "/notifications",
  },
  // {
  //   id: AppHeaderItemId.CHAT,
  //   icon: Icons.AppHeader.Chat,
  //   path: "/chat",
  // },
  {
    id: AppHeaderItemId.LOGOUT,
    icon: Icons.AppHeader.LogoutArrow,
    path: "/logout",
  },
];
